'use client';

import { c as _c } from "react/compiler-runtime";
import { KeyboardEvent, ReactElement, memo, useRef, useState } from 'react';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import classNames from 'clsx';
import styles from './bazaarvoice-review-stars-input.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly value: number;
  readonly onChange: (value: number) => void;
  readonly maxStars?: number;
  readonly disabled?: boolean;
}
const DEFAULT_MAX_STARS = 5;
function BazaarvoiceReviewStarsInputComponent(t0) {
  const $ = _c(18);
  const {
    value,
    onChange,
    maxStars: t1,
    disabled: t2
  } = t0;
  const maxStars = t1 === undefined ? DEFAULT_MAX_STARS : t1;
  const disabled = t2 === undefined ? false : t2;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-write-review-modal");
  const [hoveredStar, setHoveredStar] = useState(null);
  const displayValue = hoveredStar ?? value;
  const activeStar = value > 0 ? value : 1;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const starButtonRefs = useRef(t3);
  let t4;
  if ($[1] !== maxStars || $[2] !== onChange) {
    t4 = (event, star) => {
      let nextStar = null;
      if (event.key === "ArrowRight" || event.key === "ArrowUp") {
        nextStar = Math.min(star + 1, maxStars);
      } else {
        if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
          nextStar = Math.max(star - 1, 1);
        }
      }
      if (nextStar !== null) {
        event.preventDefault();
        onChange(nextStar);
        starButtonRefs.current[nextStar - 1]?.focus();
      }
    };
    $[1] = maxStars;
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleKeyDown = t4;
  let t5;
  if ($[4] !== formatMessage) {
    t5 = formatMessage("ratingLabel");
    $[4] = formatMessage;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeStar || $[7] !== disabled || $[8] !== displayValue || $[9] !== formatMessage || $[10] !== handleKeyDown || $[11] !== maxStars || $[12] !== onChange || $[13] !== value) {
    t6 = Array.from({
      length: maxStars
    }, (_, index) => {
      const star_0 = index + 1;
      const isFilled = star_0 <= displayValue;
      return <button key={star_0} ref={element => {
        starButtonRefs.current[index] = element;
      }} type="button" role="radio" aria-checked={star_0 === value} aria-label={formatMessage(`starAriaLabel.${star_0}`)} disabled={disabled} tabIndex={star_0 === activeStar ? 0 : -1} className={classNames(styles["bazaarvoice-review-stars-input__star"], {
        [styles["bazaarvoice-review-stars-input__star--filled"]]: isFilled
      })} onClick={() => onChange(star_0)} onKeyDown={event_0 => handleKeyDown(event_0, star_0)} onMouseEnter={() => setHoveredStar(star_0)} onMouseLeave={() => setHoveredStar(null)}><ImageComponent src="/assets/icons/star_rate.svg" height={32} width={32} alt="" /></button>;
    });
    $[6] = activeStar;
    $[7] = disabled;
    $[8] = displayValue;
    $[9] = formatMessage;
    $[10] = handleKeyDown;
    $[11] = maxStars;
    $[12] = onChange;
    $[13] = value;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className={styles["bazaarvoice-review-stars-input"]} role="radiogroup" aria-label={t5}>{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
export default memo(BazaarvoiceReviewStarsInputComponent);